import { TemplateWrapper } from './Wrapper';
import { Controller } from 'react-hook-form';
import { Textarea } from '@design-system/components/textarea/textarea';
import { EditWorkoutVM } from '../../view-models/workoutEdit.viewModel';
import { WorkoutItemTemplates } from '../../view-models/mappers';
import { ArrayItem } from '@client/new/helpers/types';
import { Video } from '../../models/workout.domain';
import { Hint, HintType } from '../../components/Hint';
import { TitleInputWithHints } from '../../components/titleInputWithHints/TitleInputWithHints';
import { MediaPreview } from '../../components/MediaPreview';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@design-system/components/button/button';

type LongVideoProps = { index: number; expand: boolean } & Pick<
  EditWorkoutVM,
  | 'influencerId'
  | 'dispatch'
  | 'control'
  | 'submitting'
  | 'isClass'
  | 'inputHints'
  | 'readonly'
  | 'exerciseSuggestions'
> &
  Pick<ArrayItem<WorkoutItemTemplates>, 'header' | 'menuItems'> &
  Video;

export const LongVideo = (p: LongVideoProps) => (
  <div>
    <TemplateWrapper {...p}>
      <div className="bg-white w-full flex flex-col md:flex-row p-4 gap-6 rounded-b-xl">
        {p.media ? (
          <MediaPreview
            media={p.media}
            videoType="long"
            removeVideo={() =>
              p.dispatch('removeMedia', {
                index: p.index,
                isYoutube: !!p.youtubeId,
              })
            }
            youtubeId={p?.youtubeId}
            disabled={p.readonly}
          />
        ) : (
          <div className="w-[244px] h-[220px]">
            <Button
              color="neutral"
              onClick={() =>
                p.dispatch('openLibrary', {
                  index: p.index,
                  type: 'long',
                  action: 'update',
                })
              }
              leftIcon={faPlus}
              disabled={p.readonly}
            >
              Add
            </Button>
          </div>
        )}
        {p.isClass ? null : (
          <div className="w-full flex flex-col gap-2">
            <Controller
              name={`exercises.${p.index}.name`}
              control={p.control}
              render={({ field: { onChange, value }, fieldState }) => (
                <TitleInputWithHints
                  required={true}
                  value={value}
                  onChange={onChange}
                  onBlur={() => {
                    p.dispatch('clearRecommendations');
                  }}
                  disabled={p.submitting || p.readonly}
                  error={fieldState.error?.message}
                  exerciseSuggestions={p.exerciseSuggestions}
                  onUpdate={(description: string, uuid: string) =>
                    p.dispatch('exerciseTitleUpdate', {
                      index: p.index,
                      description,
                      uuid,
                    })
                  }
                />
              )}
            />
            <Controller
              name={`exercises.${p.index}.description`}
              control={p.control}
              render={({ field: { onChange, value }, fieldState }) => (
                <Textarea
                  label="Description"
                  rows={4}
                  disabled={p.submitting || p.readonly}
                  value={value}
                  onChange={onChange}
                  error={fieldState.error?.message}
                />
              )}
            />
            <Hint
              hint={p.inputHints?.[p.uuid]}
              onUpdate={(hint: HintType) =>
                p.dispatch('applyHint', {
                  index: p.index,
                  hint,
                  uuid: p.uuid,
                })
              }
            />
          </div>
        )}
      </div>
    </TemplateWrapper>
  </div>
);
